module.exports = __webpack_public_path__ + "static/img/zongji3.d67dcef2.png";